/* eslint-disable */

export default {
    init() {

        $(document).ready(function() {

        });

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/routes/home.js